import React from 'react'
import SubmissionForm from '../Components/SubmissionForm'

const Submission = () => {
  return (
    <div className='   bg-bgblue  rounded-lg lg:mx-48 lg:ml-64  text-justify' >
          <SubmissionForm/>
        </div>
  )
}

export default Submission